import { Chip } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import {
  breezeScoreToLabel,
  RemediationTypeChip,
  VulnerabilityTypeChip,
} from "../../../../utils/chipsData";

const useTypeProperties = (
  type,
  value,
  keyMapping = null,
  useValueAsLabel = null,
  useShortLabel = false,
  disabled
) => {
  const colors = useColors();

  if (RemediationTypeChip[type]) {
    let typeKey = value;
    if (keyMapping) {
      typeKey = keyMapping(value);
    }
    if (RemediationTypeChip[type][typeKey]) {
      let { label, color } = RemediationTypeChip[type][typeKey];
      if (useValueAsLabel) {
        label = value;
      }
      if (useShortLabel) {
        label = RemediationTypeChip[type][typeKey].shortLabel;
      }
      return {
        label,
        backgroundColor: disabled
          ? colors.action_disabled_bg
          : colors[`${color}_bg`],
        textColor: disabled ? colors.text_disabled : colors[`${color}_text`],
      };
    }
  } else if (VulnerabilityTypeChip[type]) {
    let typeKey = value;
    if (keyMapping) {
      typeKey = keyMapping(value);
    }
    if (VulnerabilityTypeChip[type][typeKey]) {
      let { label, color } = VulnerabilityTypeChip[type][typeKey];
      if (useValueAsLabel) {
        label = value;
      }
      return {
        label,
        backgroundColor: disabled
          ? colors.action_disabled_bg
          : colors[`${color}_bg`],
        textColor: disabled ? colors.text_disabled : colors[`${color}_text`],
      };
    }
  } else if (type === "breezeScore") {
    let { label, color } = breezeScoreToLabel(value);
    return {
      label,
      backgroundColor: colors[`${color}_bg`],
      textColor: colors[`${color}_text`],
    };
  }

  // default fallback
  return {
    label: value,
    backgroundColor: colors.grey_8percent,
    textColor: colors.common_black,
  };
};

const ChipColor = ({
  value,
  type = null,
  width = 90,
  size = "medium",
  keyMapping = null,
  useValueAsLabel = null,
  useShortLabel = false,
  disabled = false,
  labelWidth = false,
  defaultColor = false,
  style = {},
  ...props
}) => {
  const colors = useColors();
  const small = 18;
  const medium = 24;
  const large = 36;

  let height;
  switch (size) {
    case "small":
      height = small;
      break;
    case "medium":
      height = medium;
      break;
    case "large":
      height = large;
      break;
    default:
      height = large;
      break;
  }

  const { label, backgroundColor, textColor } = useTypeProperties(
    type,
    value,
    keyMapping,
    useValueAsLabel,
    useShortLabel,
    disabled
  );
  return (
    <Chip
      label={label}
      style={{
        backgroundColor: defaultColor ? colors.grey_8percent : backgroundColor,
        color: defaultColor ? colors.text_primary : textColor,
        fontWeight: "regular",
        fontSize: "12px",
        height: height,
        borderRadius: "6px",
        padding: "8px",
        ...(!labelWidth && { width: width }),
        ...style,
      }}
      sx={{
        "& .MuiChip-label": {
          padding: 0,
        },
      }}
      {...props}
    />
  );
};

export default ChipColor;
